import { render, staticRenderFns } from "./PluginsDownloadCard.vue?vue&type=template&id=3a38adcc&scoped=true&"
import script from "./PluginsDownloadCard.vue?vue&type=script&lang=ts&"
export * from "./PluginsDownloadCard.vue?vue&type=script&lang=ts&"
import style0 from "./PluginsDownloadCard.vue?vue&type=style&index=0&id=3a38adcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38adcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
